const useRequestVerificationToken = (accessToken: string) => {
 
  const getToken = async () => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const response = await fetch(process.env.REACT_APP_API_URL + `/api/v3.0/accounts/request/token`, {
      headers,
      mode: 'cors',
      credentials: 'include'
    });
 
    const data = await response.json();    
 
    return data.token;
  };
 
 
    return getToken;
};
 
export default useRequestVerificationToken;